export interface PlaceOrderRequestBody {
  paymentResponse?: PaymentTransactionData[];
  authenticationResponse?: PaymentTransactionData[];
}

export class PaymentTransactionData {
  /**
   * @param code is consignment code
   * @param value is JWT token from delego or response object from Stripe
   * @param merchantId
   * @param type - title for place-order/log-error request entry
   * @param paymentProvider - optional, payment provider id e.g. STRIPE or DELEGO
   */
  constructor(
    public code: string,
    public value: any,
    public merchantId: string,
    public type: string,
    public paymentProvider?: string
  ) {}
}

export const PaymentPayloadType = {
  PAYMENT_TRANSACTION: 'paymentTransaction',
  PAYMENT_AUTHENTICATION_FAILURE: 'paymentAuthenticationFailure',
  PAYMENT_AUTHORIZATION_FAILURE: 'paymentAuthorizationFailure',
};
